<div class="alert alert--error new-payment-method-failed">
  @if(hasTitleMessage()) {
    <h3 class="body-600" [class.ta--left]="hasTitleMessage()">{{ title() }}</h3>
  }

  <p [class.ta--left]="hasTitleMessage()">{{ message() }}</p>
</div>
